import React from 'react';
import PropTypes from 'prop-types';
import { EmojiIcon } from '../EmojiIcon';
import styles from './ProductSlideContentV4.css';

function ProductSlideContentV4({ spriteVersion }) {
    return (
        <div className={styles.form}>
            <div className={styles.cardStack}>
                <div className={styles.cardBehind2} />
                <div className={styles.cardBehind1} />
                <div className={styles.card}>
                    <EmojiIcon name='heart-red' version={spriteVersion} className={styles.emoji} />
                    <p className={styles.cardQuestion}>Which family tradition would you never want to lose?</p>
                    <span className={styles.badge}>Sample question</span>
                </div>
            </div>
            <h2 className={styles.heading}>The stories you’ll uncover, one question at a time</h2>
            <p className={styles.description}>Each question comes from your last answer. That's how you end up telling the story you'd never have thought to tell.</p>
        </div>
    );
}

ProductSlideContentV4.propTypes = {
    spriteVersion: PropTypes.string.isRequired
};

export {
    ProductSlideContentV4
};
